












































































































import {Component, Vue} from 'vue-property-decorator';

@Component({
  name: 'MemberOperations',
})
export default class MemberOperations extends Vue {

    public get memberGivenName() {
      return this.$store.state.member.givenName;
    }

    public get memberSurname() {
      return this.$store.state.member.surname;
    }

    public get isMemberAuthenticated() {
      return this.$store.state.member.authenticated;
    }

    public get tutorialText() {
      const value: boolean = this.$store.state.showTutorial;

      if ( value ) {
        return 'Hide Tutorial';
      }

      return 'Show Tutorial';
    }

    public showTutorialClick() {
      const value: boolean = this.$store.state.showTutorial;

      this.$store.commit('mutateShowTutorial', !value);
    }

}
